<template>
  <div class="tags-list page">
    <div class="search-form">
      <input type="text" v-model="query" placeholder="search" @keyup.enter="searchHandler">
      <md-button :disabled="loading" @click="resetSearch">reset</md-button>
    </div>
    <div class="add-new">
      <TagCreate @tag-added="fetchData"></TagCreate>
    </div>
    <UiDataBox :loading="loading" :isEmpty="isEmpty" :error="error">
      <div class="tags-wrapper">
        <div class="item" v-for="item in tags" :key="item.id">
          <TagViewEdit @tag-updated="fetchData" @tag-deleted="fetchData" :item="item"></TagViewEdit>
        </div>
      </div>
    </UiDataBox>
  </div>
</template>

<script>
  import * as tagsService from '../../services/tags.service'
  import TagViewEdit from './TagViewEdit.vue'
  import TagCreate from './TagCreate.vue'

  export default {
    name: 'TagsList',
    props: {
      limit: {
        type: Number,
        default: 20
      },
      page: {
        type: Number,
        default: 1
      }
    },
    components: {
      TagViewEdit,
      TagCreate
    },
    watch: {},
    data () {
      return {
        loading: false,
        error: false,
        newTagName: '',
        query: '',
        tags: [],
        pagination: {
          page: this.page,
          limit: this.limit,
          total: 0
        }
      }
    },
    methods: {
      fetchData () {
        this.loading = true
        this.error = false
        tagsService.getList()
          .then(response => {
            this.tags = response.data.content
            this.total = response.data.total
          }).catch(error => { this.error = error.message })
          .finally(() => { this.loading = false })
      },
      searchHandler () {
        this.loading = true
        this.error = false
        tagsService.find({q: this.query})
          .then(response => {
            this.tags = response.data.content
            this.total = response.data.total
          }).catch(error => { this.error = error.message })
          .finally(() => { this.loading = false })
      },
      resetSearch () {
        this.query = ''
        this.fetchData()
      }
    },
    computed: {
      isEmpty () {
        return !this.tags.length
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>

<style lang="scss" scoped>
  .tags-list.page {
    padding: 10px 0;
    .add-new, .search-form {
      background-color: $color-body;
      padding: 10px;
      margin-bottom: 10px;
    }
    .search-form {
      display: flex;
    }
    .tags-wrapper {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 49%;
        margin: 0 5px;
        padding: 0 10px;
        border-bottom: 1px solid $color-body;
        &:hover{
          background-color: $color-body;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/TagsList.vue